module.exports = __webpack_public_path__ + "static/media/used20.db6d72fe.JPG";